if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

                // Flags coming from Liquid markup on the submit button
        this.isPreorder = this.submitButton?.dataset?.preorder === 'true';
      

        // Update label when variant changes (Dawn/Impact dispatch `variant:change`)
        this._onVariantChange = (evt) => {
          const variant = evt?.detail?.variant;
          // Only react if the event originated from within the same product section/form
          const targetEl = evt.target instanceof Element ? evt.target : null;
          if (targetEl && !this.contains(targetEl) && !this.closest('section')?.contains(targetEl)) return;
          this.updateButtonForVariant(variant);
        };
        document.addEventListener('variant:change', this._onVariantChange);


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

            updateButtonForVariant(variant) {
        
        const STR = (window.variantStrings || (window.theme && window.theme.strings)) || {};
        const ADD = STR.addToCart || 'Add to cart';
        const SOLD = STR.soldOut || 'Sold out';
        const UNAV = STR.unavailable || 'Unavailable';
        const PRE  = STR.preorder || 'Pre-order';

        
        if (!variant) {
          this.submitButton?.setAttribute('disabled', 'disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = UNAV;
          return;
        }

      
        if (this.isPreorder) {

          this.submitButton?.setAttribute('disabled', 'disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = PRE;
          return;
        }

      

       
        if (variant.available) {
          this.submitButton?.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = ADD;
        } else {
          this.submitButton?.setAttribute('disabled', 'disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = SOLD;
        }
      }


      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
                    
          const STR = (window.variantStrings || (window.theme && window.theme.strings)) || {};
          if (this.isPreorder) {
            this.submitButtonText.textContent = STR.preorder || 'Pre-order';
          }  else {
            this.submitButtonText.textContent = STR.addToCart || 'Add to cart';
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }


      disconnectedCallback() {
        document.removeEventListener('variant:change', this._onVariantChange);
      }
    }
  );
}
